import { render, staticRenderFns } from "./pageCommon.vue?vue&type=template&id=520487ea&"
import script from "./pageCommon.vue?vue&type=script&lang=js&"
export * from "./pageCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports